// Allows us to get the widget id from the list of widgets that can be selected. This is not the same as the widget session id.
export const getWidgetTypeId = (versionedId: string) => versionedId?.split('@')[0];
